import { render, staticRenderFns } from "./client-lookup.vue?vue&type=template&id=4994daef"
import script from "./client-lookup.vue?vue&type=script&lang=js"
export * from "./client-lookup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports